<template>
    <div>
      <VueDraggable
        v-model="items"
        animation="150"
        ghostClass="ghost"
        class="container"
        @end="onDragEnd"
      >
        <div v-for="item in tabData" :key="item.id" class="item" 
        :style="{ 
          backgroundColor: item.active? (view === 'Edit'? emailData.root.data.backdropColor : 'white')  : 'transparent', 
          color: item.active? invertHex(emailData.root.data.backdropColor) : 'white' }" >
          <span class="itemTitle"  @click="setTabActive(item)">{{ item.title}}</span><span class="material-symbols-outlined" @click="deleteMail(item.id, item)">close</span>
        </div>
      </VueDraggable>
    </div>
  </template>
  
  <script>
  import { VueDraggable } from 'vue-draggable-plus';
  import { mapState, mapActions, mapGetters } from 'vuex';
  
  export default {
    name: 'App',
    components: {
      VueDraggable,
    },
    computed: {
      ...mapState(['emailData', 'tabData', 'view', 'defaultXml']),
      ...mapGetters(['getTabData']),
    },
    methods: {
      ...mapActions(['updateEmailData', 'updateEmailTitle', 'updateTabData','updateSingleTab', 'updateXmlFile', 'deleteTabData']),
      setTabActive(item){
        if(item.active != true){
        this.updateSingleTab(this.emailData)
        this.tabData.forEach((element) => {
          element.active = false;
        });
        item.active = true;
        console.log(item)
        const clickedData =  JSON.parse(JSON.stringify(item))
        const newTitle = clickedData.title
        const xml = clickedData.xml ? clickedData.xml : this.defaultXml
        console.log(xml)
        delete clickedData.active
        this.updateEmailData(clickedData)
        this.updateEmailTitle(newTitle)
        this.updateXmlFile(xml)
      }
      },
      deleteMail(id, item){
        this.deleteTabData(id)
        console.log(item.active)
        if(item.active) {
          this.tabData[0].active = true 
          this.setTabActive(this.tabData[0])}
        
      },
      onDragEnd() {
      // Die neue Reihenfolge des Arrays an den Vuex Store senden
      this.updateTabData(this.items);
      },
      invertHex(hex) {
      // Entferne das '#' Zeichen, falls es vorhanden ist
        hex = hex.replace('#', '');

      // Sicherstellen, dass der Hex-String genau 6 Zeichen hat
      if (hex.length === 3) {
        // Wenn der Hex 3 Zeichen hat (Kurzschreibweise), erweitere ihn auf 6 Zeichen
        hex = hex.split('').map(char => char + char).join('');
      }

      // Konvertiere den Hex-String zu Großbuchstaben
      hex = hex.toUpperCase();

      // Überprüfen, ob der Hex-String gültig ist
      if (hex.length !== 6 || /[^0-9A-F]/i.test(hex)) {
        console.error(`Ungültiger Hex-Wert: ${hex}`);
        return '#FFFFFF'; // Standardfarbe, falls Hex ungültig ist
      }

      // Hex-Werte in RGB konvertieren
      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);

      // Berechne die relative Luminanz
      const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
      console.log(luminance)
      // Definiere einen Schwellenwert für sehr helle Farben
      const threshold = 200;
      if (this.view !== 'Edit') return '#000000'
      // Verwende Schwarz für sehr helle Farben (nahe Weiß)
      if (luminance > threshold) {
        return '#000000'; // Für sehr helle Farben Schwarz
      } else {
        return '#FFFFFF'; // Für andere Farben Weiß
      }}
          }
        };
  </script>
  
  <style scoped>
  .container {
    display: grid;
    gap: 0px;
    grid-template-columns: auto auto auto auto auto;
    justify-content: left;
    background: linear-gradient(135deg, var(--primary-color) 0, var(--secondary-color) 70%);
  }
  .item {
    width: 150px;
    background-color: transparent;
    height: 20px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    border-right: 1px solid white;
    display: flex; /* Flexbox-Layout */
    justify-content: space-between; /* Inhalt und Symbol voneinander trennen */
    align-items: center; /* Vertikale Zentrierung */
    padding: 5px;
    cursor: pointer;
  }

  .itemTitle {
    white-space: nowrap; /* Verhindert den Umbruch in eine neue Zeile */
    overflow: hidden; /* Versteckt alles, was über den Container hinausgeht */
    text-overflow: ellipsis; /* Fügt "..." am Ende des überlaufenden Textes hinzu */
  }
  

  .material-symbols-outlined{
    margin-left: auto; /* Automatischer Abstand zum linken Inhalt (Text) */
    font-size: 18px;
  }
  </style> 